/**
 * クイックビュー（2026-08-08）。
 * カードの「すぐ見る」から、遷移せずモーダルで商品を開いてカートに入れる。
 * 中身は Section Rendering API（?section_id=sekka-quickview）で本物のLiquidが描く
 * ＝カードや商品情報の定義が変わっても自動で追従する（お気に入り一覧と同じ思想）。
 *
 * カート追加はモーダル内のフォームが /cart/add へ飛ぶだけなので、
 * カートドロワーの横取りがそのまま効く。追加が始まったらモーダルは閉じる。
 *
 * 【速さについて】
 * 押してから取りに行くと、実測で200ms前後は必ず待つことになる。
 * そこで「押しそうな気配」で先に取っておく:
 *   PC → カードにポインタが乗った時点
 *   SP → 指が触れた時点（タップが確定するまでに100〜300msあるので大体間に合う）
 * 取れたHTMLは handle をキーに持っておき、2回目以降は取りに行かない。
 * 先読みが間に合わなかったときだけ「読み込んでいます…」が一瞬見える。
 */
(function () {
  var modal = document.querySelector('[data-sk-qv]');
  if (!modal) return;
  var overlay = document.querySelector('[data-sk-qv-overlay]');
  var body = modal.querySelector('[data-sk-qv-body]');

  var cache = new Map(); // url -> HTML文字列
  var inflight = new Map(); // url -> Promise（同じ商品を二重に取りに行かない）

  function sectionUrl(url) {
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=sekka-quickview';
  }

  /** 取得してキャッシュに載せる。失敗しても握りつぶす（先読みは失敗しても害がない） */
  function load(url) {
    if (cache.has(url)) return Promise.resolve(cache.get(url));
    if (inflight.has(url)) return inflight.get(url);

    var pr = fetch(sectionUrl(url))
      .then(function (r) {
        return r.ok ? r.text() : null;
      })
      .then(function (html) {
        inflight.delete(url);
        if (html) cache.set(url, html);
        return html;
      })
      .catch(function () {
        inflight.delete(url);
        return null;
      });

    inflight.set(url, pr);
    return pr;
  }

  /**
   * モーダル内の画像スライダーを起こす。
   * 横スクロール＋scroll-snap なので、SPは指のスワイプがそのまま効く。
   * ドット・矢印はスクロール位置から復元するだけで、状態は持たない。
   */
  function initSlider(root) {
    var slider = root.querySelector('[data-sk-qv-slider]');
    if (!slider) return;
    var track = slider.querySelector('[data-sk-qv-track]');
    var dots = [].slice.call(slider.querySelectorAll('[data-sk-qv-dot]'));
    if (!track) return;

    function current() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function goTo(i) {
      var max = track.children.length - 1;
      var idx = Math.min(Math.max(i, 0), max);
      track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
    }
    function sync() {
      var idx = current();
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
      if (prev) prev.disabled = idx <= 0;
      if (next) next.disabled = idx >= track.children.length - 1;
    }

    var prev = slider.querySelector('[data-sk-qv-prev]');
    var next = slider.querySelector('[data-sk-qv-next]');

    track.addEventListener('scroll', function () {
      window.clearTimeout(track._qvT);
      track._qvT = window.setTimeout(sync, 60);
    });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        goTo(i);
      });
    });
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });

    // キーボードでも送れるようにする
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowRight') { ev.preventDefault(); goTo(current() + 1); }
      if (ev.key === 'ArrowLeft') { ev.preventDefault(); goTo(current() - 1); }
    });

    sync();
  }

  function toggle(open) {
    modal.hidden = !open;
    overlay.hidden = !open;
    document.body.style.overflow = open ? 'hidden' : '';
    if (!open) body.innerHTML = '';
  }

  /** HTMLを流し込む。失敗したら商品ページへ普通に飛ばす（動線を止めない） */
  function render(html, url) {
    if (!html) {
      window.location.href = url;
      return;
    }
    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    var inner = tpl.content.querySelector('[data-sk-qv-inner]');
    if (!inner) {
      window.location.href = url;
      return;
    }
    body.innerHTML = '';
    body.appendChild(inner);
    initSlider(inner);
    var close = modal.querySelector('[data-sk-qv-close]');
    if (close) close.focus();
  }

  function open(url) {
    // 先読みが済んでいれば、待ち時間ゼロでそのまま描く
    if (cache.has(url)) {
      toggle(true);
      render(cache.get(url), url);
      return;
    }
    var T = (window.Sekka && window.Sekka.t) || {};
    body.innerHTML = '<p class="sk-qv__loading"></p>';
    body.firstChild.textContent = T.loading || 'Loading…';
    toggle(true);
    load(url).then(function (html) {
      // 待っている間に閉じられていたら描かない
      if (modal.hidden) return;
      render(html, url);
    });
  }

  // ---- 先読み ----
  // pointerover はバブルするので document 1枚で拾える（pointerenter は拾えない）
  document.addEventListener('pointerover', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-sk-quickview]');
    if (btn) load(btn.dataset.skQuickview);
  });
  // SPはhoverが無いので、指が触れた時点で走らせる
  document.addEventListener(
    'touchstart',
    function (ev) {
      var btn = ev.target.closest && ev.target.closest('[data-sk-quickview]');
      if (btn) load(btn.dataset.skQuickview);
    },
    { passive: true }
  );

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-sk-quickview]');
    if (btn) {
      ev.preventDefault();
      open(btn.dataset.skQuickview);
      return;
    }
    if (ev.target.closest('[data-sk-qv-close]')) toggle(false);
  });

  overlay.addEventListener('click', function () {
    toggle(false);
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && !modal.hidden) toggle(false);
  });

  // モーダル内のフォームが送信されたら（＝カートドロワーが開くので）閉じる
  document.addEventListener('submit', function (ev) {
    if (!modal.hidden && modal.contains(ev.target)) {
      setTimeout(function () {
        toggle(false);
      }, 250);
    }
  });
})();
